import { combineReducers } from 'redux';
import register from './registerReducer';

import profile from './profile';
import post from './post';
const rootReducer = combineReducers({
  register,
  profile,
  post,
});

export default rootReducer;
